export type DiseaseAutoPeriod = { dpcfy: number; dateFrom: string; dateTo: string };

export function readDpcYear(raw: string): number | null {
  return raw === 'all' ? null : raw === '2024' ? 2024 : 2026;
}

/** Invalid legacy URL periods must not suppress automatic initialization. */
export function diseaseUrlPeriod(from: string | null, to: string | null, fy: number | null) {
  const empty = {dateFromOverride:null, dateToOverride:null};
  const valid = (v:string|null) => !v || (/^\d{4}-\d{2}-\d{2}$/.test(v) &&
    Number.isFinite(Date.parse(v)) && new Date(v).toISOString().slice(0,10) === v &&
    (fy == null || (v >= `${fy}-06-01` && v <= `${fy+2}-05-31`)));
  if (!valid(from) || !valid(to) || (from && to && from > to)) return empty;
  return {dateFromOverride:from, dateToOverride:to};
}

/** Default period stays inside the selected DPC revision, even before metadata arrives. */
export function diseasePeriod(asOfMonth: string, dpcfy: number | null = null, auto: DiseaseAutoPeriod | null = null): {dateFrom:string;dateTo:string} {
  if (auto && auto.dpcfy === dpcfy) return {dateFrom:auto.dateFrom, dateTo:auto.dateTo};
  const [year,month]=asOfMonth.slice(0,7).split('-').map(Number);
  const iso=(date:Date)=>date.toISOString().slice(0,10);
  let dateFrom=iso(new Date(Date.UTC(year,month-12,1)));
  let dateTo=iso(new Date(Date.UTC(year,month,0)));
  if(dpcfy===2024||dpcfy===2026){
    const start=`${dpcfy}-06-01`,end=`${dpcfy+2}-05-31`;
    if(dateTo<start) return {dateFrom:start,dateTo:iso(new Date(Date.UTC(dpcfy,6,0)))};
    if(dateTo>end){
      dateTo=end;
      dateFrom=iso(new Date(Date.UTC(dpcfy+1,5,1)));
    }
    if(dateFrom<start)dateFrom=start;
  }
  return {dateFrom,dateTo};
}
